import React from 'react';
import classNames from 'classnames';
import classes from './ZoomButton.module.scss';
import PropTypes from 'prop-types';

const ZoomButton = ({
  children,
  onClick,
  variant = 'primary',
  borderRadius,
  size = 'large',
  ...rest
}) => {
  return (
    <button
      {...rest}
      className={classNames(
        classes.zoomButton,
        classes[variant],
        classes[size] // apply size class
      )}
      onClick={onClick}
      style={{ borderRadius }}
    >
      {children}
    </button>
  );
};

ZoomButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  borderRadius: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'lightblue', 'danger', 'outline', 'disabled']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

ZoomButton.defaultProps = {
  onClick: () => {},
  variant: 'primary',
  size: 'large', // default = current design
};


export default ZoomButton;
